// React
import React, { memo } from 'react'
import PropTypes from 'prop-types'

// Components
import BLocationPicker from 'ui/blocks/Picker/Location'
import Icon from 'ui/components/Icon'
import Div from 'ui/elements/Div'
import Skeleton from 'ui/blocks/Skeleton'

// Libraries
import { components } from 'react-select'
import { isEmpty } from 'lodash'

const LocationPickerSingleValueComponent = (props) => {
  const location = props.selectProps.locations.toList().find((selectLocation) => {
    return selectLocation.id === props.data?.value
  })

  const deliveryDistance = location && props.selectProps.deliveryDistances?.find((record) => {
    return record.locationId === location.id
  })

  const locationName = props.selectProps.title ?
    <BLocationPicker.Subtitle>{location?.name}</BLocationPicker.Subtitle> :
    <BLocationPicker.Title>{location?.name}</BLocationPicker.Title>

  const showDistanceForLocation = location && props.selectProps.showDeliveryDistances

  return (
    <components.SingleValue {...props}>
      <BLocationPicker.Control>
        <Icon icon={props.selectProps.icon || 'store'} />
        <Div>
          {props.selectProps.title && <BLocationPicker.Title>{props.selectProps.title}</BLocationPicker.Title>}
          {locationName}
          {location?.address && props.selectProps.showAddress && (
            <BLocationPicker.Subtitle>{location.address}</BLocationPicker.Subtitle>
          )}
        </Div>
        {showDistanceForLocation && isEmpty(deliveryDistance) && <Skeleton width={50} />}
        {showDistanceForLocation && !isEmpty(deliveryDistance) && (
          <Div>{deliveryDistance.distance} {deliveryDistance.distance_unit}</Div>
        )}
      </BLocationPicker.Control>
    </components.SingleValue>
  )
}

LocationPickerSingleValueComponent.propTypes = {
  selectProps: PropTypes.shape({
    locations: PropTypes.object,
    title: PropTypes.any,
    icon: PropTypes.string,
    deliveryDistances: PropTypes.any,
    showDeliveryDistances: PropTypes.bool,
    showAddress: PropTypes.bool
  }),
  data: PropTypes.shape({
    value: PropTypes.string
  })
}

export const LocationPickerSingleValue = memo(LocationPickerSingleValueComponent)

LocationPickerSingleValue.displayName = 'LocationPicker'
